import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import withStyles from "react-jss";
import PhoneContainerHeader from "Containers/PhoneContainerHeader";
import LoginHeaderContainer from "Containers/LoginHeaderContainer";
import LoginLogic from "HOC/LoginLogic";
import { MenuWidget } from "ComponentsUI/Navigation";
import { Link } from "react-router-dom";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";
import FindTariffsHeaderContainer from "Containers/FindTariffsHeaderContainer";

const styles = theme => {
    return {
        root: {
            backgroundColor: theme.palette.colors.paleGrey,
            boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.5)",
            position: "fixed",
            zIndex: "4",
            transform: "translateY(0)",
            transition: "transform .5s ease",
            width: "100%",
            top: 0,
            left: 0,
        },
        widgetMenu: {
            display: "block",
        },
        upperPart: {
            position: "relative",
            zIndex: 2,
            backgroundColor: theme.palette.colors.paleGrey,
        },
        isHidden: {
            transform: "translateY(-200%)",
        },
        showMobile: {},
        upperWrapper: {
            display: "flex",
            alignItems: "center",
            padding: "10px 0",
        },
        menuIsHidden: {
            transform: "translate(150%, 100%)",
        },
        bottomMenu: {},
        phoneButton: {
            marginRight: "auto",
            marginLeft: "20px",
            width: "280px",
        },
        login: {
            marginLeft: "auto",
            marginTop: "-2px",
        },
        logoWrapper: {
            display: "block",
            marginRight: "auto",
            cursor: "pointer",
            flexShrink: 0,
            height: "30px",
            "& a": {
                height: "30px",
                width: "auto",
                display: "inline-block",
            },
            "& embed": {
                height: "30px",
                width: "auto",
                pointerEvents: "none",
            },
        },
        mobileMenu: {
            display: "block",
            marginLeft: "40px",
            flexShrink: 0,
            cursor: "pointer",
            "& span": {
                fontSize: "24px",
                color: theme.palette.colors.purplishBlue,
            },
        },
        searchTariffs: {
            width: "280px",
            marginLeft: "auto",
        },
        desktop: {},
        mobile: {
            display: "none",
        },
        adblock: {
            width: "100%",
            position: "absolute",
            bottom: "1px",
            transform: "translateY(100%)",
            zIndex: -1,
            transition: "transform .3s ease",
            animation: "toDown .3s ease",
            boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.5)",
        },
        adblockHidden: {
            transform: "translateY(-50%)",
        },
        carouselItem: {
            width: "100%",
        },
        carouselItemPurple: {
            backgroundColor: theme.palette.colors.purplishBlue,
        },
        carouselItemOrange: {
            backgroundColor: theme.palette.colors.orange,
        },
        carouselItemWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 0",
        },
        noPhone: {
            marginLeft: "0 !important",
        },
        carouselItemTextWrapper: {
            width: "100%",
            paddingRight: "40px",
            textAlign: "center",
        },
        carouselItemText: {
            fontFamily: theme.fonts.light,
            color: theme.palette.colors.white,
            lineHeight: 1,
            fontSize: "16px",
        },
        carouselCloseWrapper: {
            position: "relative",
        },
        carouselItemClose: {
            flexShrink: 0,
            cursor: "pointer",
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 1,
            "& span": {
                fontSize: "16px",
                color: theme.palette.colors.white,
            },
        },
        findTariffsWrapper: {
            position: "absolute",
            bottom: "-20px",
            transform: "translateY(100%)",
            left: "210px",
            visibility: "visible",
            opacity: 1,
            transition: "opacity .3s ease",
        },
        findTariffsWrapperIsHidden: {
            visibility: "hidden",
            opacity: 0,
        },
        [`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
            location: {
                width: "220px",
                marginRight: "20px",
                paddingLeft: "3px",
            },
            login: {
                marginLeft: "auto",
            },
        },
        [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
            searchTariffs: {
                width: "auto",
            },
            phoneButton: {
                width: "auto",
            },
        },
        [`@media (max-width: ${theme.media.sm})`]: {
            upperWrapper: {
                padding: "10px 0",
            },
            widgetMenu: {
                display: "none",
            },
            logoWrapper: {
                marginRight: "0",
                display: "flex",
                height: "40px",
                width: "40px",
                alignItems: "center",
                justifyContent: "center",
                "& a": {
                    height: "20px",
                    width: "auto",
                },
                "& embed": {
                    height: "20px",
                    width: "auto",
                },
            },
            upperMenu: {
                display: "none",
            },
            login: {
                display: "none",
            },
            phoneButton: {
                width: "40px",
                flexShrink: 0,
                marginLeft: "15px",
                display: "block",
                marginRight: 0,
            },
            searchTariffs: {
                margin: "0 auto",
                width: "140px",
            },
            mobileMenu: {
                display: "flex",
                height: "40px",
                width: "40px",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "8px",
                "& span": {
                    fontSize: "20px",
                },
            },
            carouselItemText: {
                fontSize: "14px",
            },
            carouselItemClose: {
                marginLeft: "10px",
                "& span": {
                    fontSize: "14px",
                },
            },
            findTariffsWrapper: {
                bottom: "0",
                left: "-20px",
                right: "-20px",
                zIndex: 2,
                width: "auto",
                transition: "transform .3s ease",
                transform: "translate(0, 100%)",
            },
            findTariffsWrapperIsHidden: {
                visibility: "visible",
                opacity: 1,
                transform: "translate(120%, 100%)",
            },
        },
    };
};

class FixedNavigation extends React.Component {
    render() {
        let classes = this.props.classes;
        let text = this.props.text;
        let onClickMenu = this.props.showFindTariffs
            ? this.props.toggleFindTariffs
            : this.props.openMobileMenu;
        let classNameWidget = classNames(classes.searchTariffs, {
            [classes.noPhone]: !this.props.showOnSite,
        });
        // onClickMenu = this.props.openMobileMenu;

        let panel = (
            <div
                id={"fixed_navigation"}
                className={classNames(classes.root, "fixed", {
                    [classes.isHidden]: !this.props.showNavigation,
                })}
            >
                <div className={classes.upperPart}>
                    <Container>
                        <Row>
                            <Col xs="12">
                                <div className={classes.widgetMenu}>
                                    {this.props.widgetMenu}
                                </div>
                                <div className={classes.upperWrapper}>
                                    <div className={classes.logoWrapper}>
                                        <Link
                                            aria-label={this.props.hrefToMain}
                                            to={this.props.hrefToMain}
                                        >
                                            <embed src={this.props.logo} />
                                        </Link>
                                    </div>
                                    <div className={classNameWidget}>
                                        <MenuWidget
                                            onClick={
                                                this.props.toggleFindTariffs
                                            }
                                            icon={
                                                <span className="icon24 icon-magnifier-1" />
                                            }
                                            text={text.compareTariffs}
                                            passiveTheme={false}
                                            active={this.props.showFindTariffs}
                                        />
                                    </div>
                                    {this.props.xs ? (
                                        <div className={classes.phoneButton}>
                                            <PhoneContainerHeader
                                                fixedTheme={true}
                                                passiveTheme={false}
                                                phone404={this.props.phone404}
                                            />
                                        </div>
                                    ) : (
                                        (this.props.showOnSite ||
                                            this.props.phone404) && (
                                            <div
                                                className={classes.phoneButton}
                                            >
                                                <PhoneContainerHeader
                                                    fixedTheme={true}
                                                    passiveTheme={false}
                                                    phone404={
                                                        this.props.phone404
                                                    }
                                                />
                                            </div>
                                        )
                                    )}
                                    <div className={classes.login}>
                                        <LoginLogic>
                                            <LoginHeaderContainer
                                                purpleTheme={true}
                                                onlyLogo={true}
                                            />
                                        </LoginLogic>
                                    </div>
                                    <div
                                        className={classNames(
                                            classes.mobileMenu,
                                            "onlyNotXs"
                                        )}
                                        onClick={this.props.openMenu}
                                    >
                                        <span className="icon24 icon-hamburger-menu-1" />
                                    </div>
                                    <div
                                        className={classNames(
                                            classes.mobileMenu,
                                            "onlyXs"
                                        )}
                                        onClick={onClickMenu}
                                    >
                                        {!this.props.showFindTariffs && (
                                            <span className="icon24 icon-hamburger-menu-1" />
                                        )}
                                        {!!this.props.showFindTariffs && (
                                            <span className="icon24 icon-close" />
                                        )}
                                    </div>
                                    <div
                                        className={classNames(
                                            classes.findTariffsWrapper,
                                            {
                                                [classes.findTariffsWrapperIsHidden]: !this
                                                    .props.showFindTariffs,
                                            }
                                        )}
                                    >
                                        <DeclinationContainerNew>
                                            <FindTariffsHeaderContainer
                                                text={this.props.text}
                                                refs={this.props.refs}
                                                onClose={
                                                    this.props.toggleFindTariffs
                                                }
                                                cutWrapper={true}
                                            />
                                        </DeclinationContainerNew>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );

        // let node = document.querySelector("#fixedPanelMenu")
        // if (typeof window !== 'undefined' && node !== null) {
        //     return ReactDOM.createPortal(
        //         panel,
        //         node
        //     )
        // }
        return panel;
    }
}

export default withStyles(styles)(FixedNavigation);
